/**
 * Missile Command - Main Entry Point
 * Initializes the game engine and starts the application.
 */

import { Game } from './game/Game.js';

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', () => {
  const canvas = document.getElementById('game-canvas');
  if (!canvas) {
    console.error('Game canvas element not found!');
    return;
  }

  // Initialize and start the game
  const game = new Game(canvas);
  game.init();

  // Expose game instance for testing / Playwright access
  window.__game = game;
});
